/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageCustomers from "./manageCustomers";
import ManageCustomerDetail from "./manageCustomers/view";
import ManageMaintenanceTeam from "./manageMaintenanceTeam";
import ManageCategories from "./manageCategories";
import ManagePayments from "./managePayments";
import ManageSubadmin from "./manageSubadmin";
import ManageAnalytics from "./manageAnalytics";
import ManageCustomerSupport from "./manageCustomerSupport";
import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageReviews from "./manageReviews";
import ManageCms from "./manageCms";
import AddCustomer from "./manageCustomers/add";
import AddTeam from "./manageMaintenanceTeam/add";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import MaintenanceTeamDetail from "./manageMaintenanceTeam/view";
import ManageIssues from "./manageIssues";
import ManageOffers from "./manageIssues/offers";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import ManageCustomerIssues from "./manageCustomerIssues";
import PermissionDenied from "./permission";
import PrivacyPolicyUrl from "./privacyPolicy";
import DeletePolicy from "./deletePolicy";
import ContactSupport from "./contactSupport";

export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageCustomers,
  ManageCustomerDetail,
  AddCustomer,
  ManageMaintenanceTeam,
  MaintenanceTeamDetail,
  AddTeam,
  ManageIssues,
  ManageOffers,
  ManageCategories,
  ManagePayments,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,
  ManageAnalytics,
  ManageCustomerSupport,
  ManageNotifications,
  RecievedNotifications,
  ManageReviews,
  ManageCms,
  ManageProfile,
  EditProfile,
  ChangePassword,
  ManageCustomerIssues,
  PermissionDenied,
  PrivacyPolicyUrl,
  DeletePolicy,
  ContactSupport,
};
